// extracted by mini-css-extract-plugin
export var black = "_46-6";
export var brand = "_46-1";
export var ddefault = "_46-0";
export var error = "_46-3";
export var gray = "_46-2";
export var highContrast = "_46-8";
export var outline = "_46-7";
export var success = "_46-5";
export var warning = "_46-4";